import { Component } from 'preact';
import DropdownTreeSelect from 'react-dropdown-tree-select';
import '../Styles/ConfigureStyles.css';
import 'react-dropdown-tree-select/dist/styles.css';
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from '@material-ui/core/FormControlLabel';
//import HistogramComponent from './HistogramComponent.js';

class ConfigureComponent extends Component {

  constructor(props){
    super(props)
    this.state = {
      checked_nodes: [],  //Casillas seleccionadas del DropdownTree
      filteredData_panel:[],
      data: { //Todas las casillas del DropdownTree
        label: 'Categories',
        value: 'searchme',
        expanded: true,
        children: [
          {
            label: '■ Alaskan ultramafic',
            value: '0',
            children:[],
            limit:[0,385],
          },
          {
            label: '■ Alkali/Lamprophyres',
            value: '1',
            limit:[386,2738],
            children: [
              {
                label: '■ alkali basalt etc',
                color:'red',
                value: '1.0',
                limit:[386,982],
              },
              {
                label: '■ kimberlite',
                value: '1.1',
                limit:[983,2590],
              },
              {
                label: '■ lamproite',
                value: '1.2',
                limit:[2591,2738],
              },/*
              {
                label: '■ lamprophyre',
                value: '1.3',
                limit:[2732,2828],
              },
              {
                label: '■ potassic',
                value: '1.4',
                limit:[2829,2951],
              }*/
            ]
          },
          {
            label: '■ Basalt',
            value: '2',
            limit:[2739,7905],
            children: [
              {
                label: '■ boninite',
                value: '2.0',
                limit:[2739,3269],
              },
              {
                label: '■ flood basalt',
                value: '2.1',
                limit:[3270,3852],
              },
              {
                label: '■ hawaii lava lake',
                value: '2.2',
                limit:[3853,4297],
              },
              {
                label: '■ island arc',
                value: '2.3',
                limit:[4298,5451],
              },
              {
                label: '■ ocean floor',
                value: '2.4',
                limit:[5452,7306],
              },
              {
                label: '■ ocean island',
                value: '2.5',
                limit:[7307,7905],
              },/*
              {
                label: '■ ophiolite',
                value: '2.6',
                limit:[8108,8159],
              },
              {
                label: '■ undefined',
                value: '2.7',
                limit:[8160,8903],
              },*/
            ],
          },
          {
            label: '■ Komatiite',
            value: '3',
            limit:[7906,11017],
            children: [
              {
                label: '■ chromite cores amphibolite AUDK',
                value: '3.0',
                limit:[8264,9333],
              },
              {
                label: '■ chromite cores amphibolite ADK',
                value: '3.1',
                limit:[7906,8263],
              },
              {
                label: '■ chromite cores greenschist',
                value: '3.2',
                limit:[9334,10462],
              },
              {
                label: '■ sulphide',
                value: '3.3',
                limit:[10463,11017],
              },
            ],
          },/*
          {
            label: 'Laterite',
            value: '4',
            children:[],
            limit:[12000,12141],
          },*/
          {
            label: '■ Layered intrusion',
            value: '4',
            limit:[11018,15245],
            children: [
              {
                label: '■ chromitite',
                value: '4.0',
                limit:[11018,11860],
              },
              {
                label: '■ other',
                value: '4.1',
                limit:[11861,14447],
              },
              {
                label: '■ subvolc sills/dykes',
                value: '4.2',
                limit:[14448,15245],
              },
            ],
          },
          {
            label: '■ Metamorphic',
            value: '5',
            limit:[15246,16901],
            children: [
              {
                label: '■ magnetite rims amphibolite',
                value: '5.0',
                limit:[15246,16739],
              },
              {
                label: '■ magnetite rims greenschist',
                value: '5.1',
                limit:[16740,16901],
              }
            ],
          },
          {
            label: '■ Ophiolite',
            value: '6',
            limit:[16902,22350],
            children: [
              {
                label: '■ chromitite',
                value: '6.0',
                limit:[19682,21557],
              },
              {
                label: '■ high p alpine',
                value: '6.1',
                limit:[21557,21930],
              },
              {
                label: '■ ocean floor peridotite',
                value: '6.2',
                limit:[21931,22350],
              },
              {
                label: '■ chromite',
                value: '6.3',
                limit:[16902,19681],
              },
            ],
          },
          {
            label: '■ Xenoliths',
            value: '7',
            limit:[22351,24589],
            children: [
              {
                label: '■ basalts',
                value: '7.0',
                limit:[22351,24181],
              },/*
              {
                label: '■ island arc',
                value: '8.1',
                limit:[25156,25315],
              },*/
              {
                label: '■ kimberlites',
                value: '7.1',
                limit:[24182,24589],
              },/*
              {
                label: '■ ocean floor',
                value: '8.3',
                limit:[25715,25769],
              },*/
            ],
          },
        ],
      }
    }
    this.onChange = this.onChange.bind(this);
    this.onNodeToggle = this.onNodeToggle.bind(this);
  }

  //se invoca antes de renderizar cuando se reciben nuevas propiedades o estados
  /*shouldComponentUpdate(nextProps, nextState){
  if((nextProps.flag!=0) && (nextProps.selected_data.length != this.props.selected_data.length)){ //si modifico el cjto de selected data
  this.set_data(nextProps.selected_data);
}
}*/

/*
* Método para modificar el state al seleccionar nuevas casillas al DropdownTree
*/
onChange(currentNode, selectedNodes){
  let props  = this.props;
  var  data = this.state.data;

  const cats = ["Alaskan ultramafic","Alkali/Lamprophyres","Basalt","Komatiite","Layered intrusion","Metamorphic","Ophiolite","Xenoliths"];
  const subcats = [[],
    ["alkali basalt etc","kimberlite","lamproite"],
    ["boninite","flood basalt","hawaii lava lake","island arc","ocean floor","ocean island"],
    ["chromite cores amphibolite AUDK","chromite cores amphibolite ADK","chromite cores greenschist","sulphide"],
    ["chromitite","other","subvolc sills/dykes"],
    ["magnetite rims amphibolite","magnetite rims greenschist"],
    ["chromitite","high p alpine","ocean floor peridotite","chromite"],
    ["basalts","kimberlites"]];


  var num_cat;
  var num_subcat;
  var selec_items = [];
  var checked_nodes = this.state.checked_nodes;
  var new_checked_nodes = [];

  for(let i=0; i<selectedNodes.length;i++){
    new_checked_nodes.push(selectedNodes[i].value);
  }

  for(let i = 0; i<data.children.length; i++){
    if(new_checked_nodes.includes(data.children[i].value)) {//-Si esta seleccionada toda la categ
      data.children[i].checked = true;
      for(let j = 0; j<data.children[i].children.length; j++) { //.-Si selecciono solo algunas subcat de la cat
        data.children[i].children[j].checked = true;
      }
    }
    else {
      data.children[i].checked = undefined;
      var encontre = false;
      for(let j = 0; j<data.children[i].children.length; j++) { //.-Si selecciono solo algunas subcat de la cat
        if(new_checked_nodes.includes(data.children[i].children[j].value)){
          data.children[i].children[j].checked = true;
          encontre  = true;
        }
        else {
          data.children[i].children[j].checked = undefined;
        }
      }
    }
  }

  let aux = [];
  for(let i=0; i<new_checked_nodes.length; i++){
    aux = [];
    if(new_checked_nodes[i].length==1) {//Seleccionada toda la categoria
      selec_items = selec_items.concat(d3.range(data.children[new_checked_nodes[i].charAt(0)].limit[0],data.children[new_checked_nodes[i].charAt(0)].limit[1]+1));
    }
    else {
      selec_items = selec_items.concat(d3.range(data.children[new_checked_nodes[i].charAt(0)].children[new_checked_nodes[i].charAt(2)].limit[0],data.children[new_checked_nodes[i].charAt(0)].children[new_checked_nodes[i].charAt(2)].limit[1]+1));
    }
  }

  var filteredData_umap = [],filteredData_projection = [];
  props.filteredData_umap.forEach(elem => {if(selec_items.includes(elem)) filteredData_umap.push(elem);});
  props.filteredData_projection.forEach(elem => {if(selec_items.includes(elem)) filteredData_projection.push(elem);});


  let labels=[];
  selectedNodes.map(elem =>{var str = elem.label; var newstr = str.slice(2); if(cats.includes(newstr)) {labels.push(newstr)}});
  props.cbk_selecc_category(labels);

  this.setState({data:data});
  this.setState({filteredData_panel:selec_items},()=>{props.cbk_filteredData_panel(selec_items);props.cbk_filteredData_umap(filteredData_umap);
  props.cbk_filteredData_projection(filteredData_projection);
  });
}

/*Método para setear los nodos expandidos*/
onNodeToggle (currentNode){
  var data  = this.state.data;
  var num_cat  = parseInt(currentNode.value);
  if(data.children[num_cat].expanded){
    data.children[num_cat].expanded = false;
  }
  else{
    for(let i = 0; i<data.children.length; i++){
      data.children[i].expanded = false;
    }
    data.children[num_cat].expanded = true;

  }
  this.setState({data:data});
}

render(){

  return (
    <div class="legends">
      <DropdownTreeSelect showDropdown={"always"} data={this.state.data} onChange={this.onChange} onNodeToggle={this.onNodeToggle} />
    </div>
  );
}

}
export default ConfigureComponent;
/*
<div class="container-mainHistogram">
<HistogramComponent  data={this.props.complete_data} selected_data={this.state.filteredData_panel}/>
</div>*/
